import PostGrid from './PostGrid';

export default PostGrid;
export type { PostGridPropTypes } from './PostGrid';
